import { render, staticRenderFns } from "./BUCP.vue?vue&type=template&id=6e7e8feb&"
import script from "./BUCP.vue?vue&type=script&lang=ts&"
export * from "./BUCP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports